import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70 } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2.5),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.common.white,

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      marginTop: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',

      '& img': {
        marginTop: 0,
      },
    },
  },
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: '90%',
    marginTop: theme.spacing(4),
    borderRadius: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      width: 650,
      marginTop: 0,
      zIndex: 2,
    },
  },
  titleGraphical: {
    fontSize: 34,
    fontWeight: 'bold',
    color: COLOR_GRAY_70,
  },
  optionsHeader: {
    fontSize: 18,
    '& img': {
      paddingRight: 13,
    },
  },
  descriptionGraphical: {
    fontWeight: 600,
    color: '#000',
  },
  noCreditCard: {
    fontSize: 18,
    color: COLOR_GRAY_70,
    textAlign: 'center',
  },
}));
